import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import 'rxjs/add/operator/map';
import { Constants } from '../Constants';

@Injectable()
export class SettingService {
    private serviceUrl: string = this._claims.SMUrl + "breeze/Setting/";

    constructor(private _http: Http, @Inject('Claims') private _claims: any) {
    }

    public getAllSettings() {
        return this._http.get(this.serviceUrl + "AllSettings", { headers: Constants.getJsonHeaders(this._claims.accessToken) }).map(res => res.json());
    }

    public getAllSettingsByCategory(category) {
        return this._http.get(this.serviceUrl + "GetSettingsByCategory?category=" + category, { headers: Constants.getJsonHeaders(this._claims.accessToken) }).map(res => res.json());
    }

    public setAllSettings(settings) {
        return this._http.post(this.serviceUrl + "UpdateSettings", JSON.stringify(settings), { headers: Constants.getJsonHeaders(this._claims.accessToken) }).map(res => res.json());
    }

    public getPasswordExpression() {
        return this._http.get(this.serviceUrl + "GetPasswordExpression", { headers: Constants.getJsonHeaders(this._claims.accessToken) }).map(res => res.json());
    }

    public notificationsAvailable() {
        return this._http.get(this.serviceUrl + "NotificationsAvailable", { headers: Constants.getJsonHeaders(this._claims.accessToken) });
    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./Services/SettingService.ts